import BraunWishlistController from '@/braun/Controllers/BraunWishlistController';
import ListingCompareInitiator from '@/braun/Controllers/Listing/Compare/ListingCompareInitiator';
import ProductTileHeightController from '@/braun/Controllers/Listing/ProductTileHeightController';
import DELCompareInitiator from '@/delonghi/Controllers/Compare/DELCompareInitiator';
import { checkWishlistIcon } from '@/kenwood/Controllers/KENWishlistController';
import KenwoodCompareInitiator from '@/kenwood/Controllers/Listing/KenwoodCompareInitiator';
import LazyLoadInfiniteResultsController from '@/search/Controllers/LazyLoadInfiniteResultsController';
import SearchBackToPlpController from '@/search/Controllers/SearchBackToPlpController';
import UpdateResultsController from '@/search/Controllers/UpdateResultsController';
import {
  isBraun,
  isDelonghi,
  isKenwood,
  isNutribullet,
} from '@/utils/Common/Booleans';
import EVENTS from '@/utils/Constants/Events';
import PushProductCompare from '@/utils/Controllers/PushProductCompare';

export const rebindAll = searchType => {
  LazyLoadInfiniteResultsController(searchType);
  DLG.EVE.emit(EVENTS.LISTING.COMPARE.UPDATE);

  if (isBraun) {
    // braun specific
    ProductTileHeightController();
    BraunWishlistController();
  }

  if (isKenwood) {
    checkWishlistIcon();
  }
};

export default async () => {
  UpdateResultsController();
  SearchBackToPlpController();
  LazyLoadInfiniteResultsController();

  if (isBraun) {
    // braun specific
    ProductTileHeightController();
    BraunWishlistController();
    ListingCompareInitiator();
    PushProductCompare();
  }

  if (isDelonghi || isNutribullet) {
    DELCompareInitiator();
  }

  if (isKenwood) {
    KenwoodCompareInitiator();
    checkWishlistIcon();
  }
};
